



























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PayCardManager } from "./internal/payCardManager";
import { KeypressEvent, PayCardInfo } from "./internal/types";
import PayCardImage from "./PayCardImage.vue";

export type CardNameFieldMode = "hidden" | "optional" | "mandatory" | "readOnly";
export type CVVFieldMode = "hidden" | "optional" | "mandatory";
type VForm = Vue & { validate: () => boolean };

@Component({ components: { PayCardImage } })
export default class PayCardForm extends Vue {
  @Prop({ default: "primary" }) color!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "hidden" }) nameFieldMode!: CardNameFieldMode;
  @Prop({ default: "hidden" }) cvvFieldMode!: CVVFieldMode;
  @Prop({ default: null }) value!: PayCardInfo | null;
  cardInfo: PayCardInfo = {
    cardName: "",
    cardNumber: "",
    cardExpiry: "",
    plateNumber: "",
    kilometers: 0
    // cardCvv: ""
  };
  get langKey() {
    return this.$store.state.lang.key;
  }
  get lang() {
    return this.$store.state.lang.data;
  }
  get cardManager() {
    return new PayCardManager(this.lang, this.nameFieldMode !== "hidden", this.nameFieldMode == "mandatory");
  }
  get rules() {
    return this.cardManager.validationRules();
  }
  get fCardName() {
    return this.cardManager.cardName();
  }
  get fPAN() {
    return this.cardManager.pan(this.cardInfo.cardNumber);
  }
  get fExpiry() {
    return this.cardManager.expiry();
  }
  get fCVV() {
    return this.cardManager.cvv();
  }
  get cardBrand() {
    return this.cardManager.getTheme(this.fPAN.brand);
  }

  clearData() {
    this.cardInfo = {
      cardName: "",
      cardNumber: "",
      cardExpiry: "",
      plateNumber: "",
      kilometers: 0
      // cardCvv: ""
    };
  }
  mounted() {
    if (this.value) {
      this.cardInfo = { ...this.cardInfo, ...this.value };
    }
  }

  transformToNumber(value: string) {
    const numberValue = Number(value.replace(",", "."));
    if (isNaN(numberValue)) {
      return 0;
    }
    return numberValue;
  }

  allowInput(value: string) {
    return value.replace(/[^\d,.]/g, "");
  }

  @Watch("cardInfo", { deep: true })
  onCardInfoChanged() {
    const cardNumber = this.$refs["cardNumber"] as VForm;
    const cardExpiry = this.$refs["cardExpiry"] as VForm;
    // let cardCvv = this.$refs["cardCvv"] as VForm;
    let disablePayment = true;

    if (cardNumber.validate() && cardExpiry.validate()) {
      disablePayment = false;
    }

    this.$emit("input", {
      cardInfo: { ...this.cardInfo },
      disablePayment
    });
  }

  setFlipped(value: boolean) {
    (this.$refs["cardImage"] as PayCardImage)?.setFlipped(value);
  }

  isNumber(cevt?: KeypressEvent) {
    const evt = (cevt ? cevt : window.event) as KeypressEvent;
    if (!evt) return;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
    return;
  }
}
